import { useEffect } from 'react';
import { MobileDashboardSection } from './components/DashboardStyles';
import { useDispatch, useSelector } from 'react-redux';
import { get_categories } from '../../redux/actions/productActions';
import { Box, SimpleGrid, Text } from '@chakra-ui/react';
import SearchFilterInput from 'components/Dashboard/SearchFilterInput';
import FullPagination from 'components/Dashboard/FullPagination';
import useLocalSearch from 'hooks/useLocalSearch';
import CategoryCard from 'components/Dashboard/CategoryCard';
import Loader from 'components/loader';

const Category = () => {
    const { loading, categories } = useSelector((state) => state.productReducer);
    const { onSearch, data, handlePageClick, fullData } = useLocalSearch({
        payload: categories || [],
    });

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(get_categories());
    }, [dispatch]);

    if (loading) {
        <Loader fullscreen={false} />;
    }

    return (
        <MobileDashboardSection>
            <Box>
                <Text fontSize="3xl" fontWeight="bold" textAlign="left">
                    All Categories
                </Text>
            </Box>
            <SearchFilterInput source={'all categories'} onSearch={onSearch} />
            <SimpleGrid mt="8" columns={{ sm: 1, md: 2, lg: 5 }} spacing="5">
                {data?.map((item) =>
                    item?.status === 'active' ? <CategoryCard category={item} /> : [],
                )}
            </SimpleGrid>
            <FullPagination handlePageClick={handlePageClick} fullData={fullData} />
        </MobileDashboardSection>
    );
};

export default Category;
